import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import StatusSchedules from './Status'
import TypeSchedules from './type'

function SchedulesSettings() {
    return(
        <>
        <TextMediumSM content="Schedules" />
        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <TypeSchedules/>
         </div>
         <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <StatusSchedules/>
         </div>
        
       
         </div>
         </>
    )
}

export default SchedulesSettings
